<template>
  <Vue3Lottie :animationData="SpinJSON" :height="30" :width="30" />
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import "vue3-lottie/dist/style.css";

import SpinJSON from "@/assets/lottie/loading_spin.json";

export default {
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      SpinJSON,
    };
  },
};
</script>
